/**
 * InstalmentsTab — Batch #14.329 : tuile « Acomptes » d'un dossier Tenue de livres (travailleur autonome ou société).
 * Le type est proposé d'après le type d'entité du calendrier de conformité (société → acomptes de société).
 */
import { useEffect, useState } from "react";
import { CalendarRange } from "lucide-react";
import { api } from "@/api";
import InstalmentsCalculator from "@/components/instalments/InstalmentsCalculator";

export default function InstalmentsTab({ masterId, settings }) {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    api.get(`/admin/compliance/${masterId}`, { params: { days: 1 } }).then((r) => setMeta(r.data)).catch(() => setMeta({}));
  }, [masterId]);
  const corp = meta?.entity_type === "corp";
  return (
    <div className="space-y-4" data-testid="books-instalments-tab">
      <div className="bg-white border rounded-xl p-4 flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-violet-100 text-violet-700 flex items-center justify-center flex-shrink-0"><CalendarRange className="w-5 h-5" /></div>
        <div className="text-xs text-slate-600">
          <h3 className="text-sm font-bold text-slate-800">Acomptes provisionnels du dossier</h3>
          <p className="mt-0.5">Travailleur autonome : 4 versements (15 mars · juin · septembre · décembre, seuil 1 800 $). Société : versements mensuels (ou trimestriels pour une SPCC admissible) à partir de la fin d'exercice, seuil 3 000 $. Le plan enregistré alimente le calendrier de conformité du dossier.</p>
          {meta && <p className="mt-1 text-[11px] text-slate-500" data-testid="books-instalments-entity">Type d'entité du dossier : <span className="font-semibold">{corp ? "société" : "travailleur autonome / particulier"}</span>{meta.fiscal_year_end ? ` · fin d'exercice ${meta.fiscal_year_end}` : ""} (modifiable dans Conformité › Réglages du dossier).</p>}
        </div>
      </div>
      {meta && <InstalmentsCalculator scope="books" masterId={masterId} allowCorporation defaultKind={corp ? "corporation" : "self_employed"} defaultName={settings?.legal_name || meta.master_name || ""} />}
    </div>
  );
}
